import {
  IBlackjackGame,
  IBlackjackPlayerCardsObject,
  IBlackjackPlayerPosition,
  IBlackjackRoom,
  TMaxPlayers,
} from '@api/types/blackjack';

interface IGetActivePlayersInRoomProps {
  current_game: IBlackjackGame;
  recent_games: IBlackjackGame[];
}

export const getActivePlayersInRoom = ({
  current_game,
  recent_games,
}: IGetActivePlayersInRoomProps): number => {
  const allGames: IBlackjackGame[] = [
    { ...current_game },
    ...recent_games.filter((game) => game.game_metadata.status === 'active'),
  ];

  return allGames.reduce((players, room) => players + room.players.length, 0);
};

export const getPlayerPositionInTable = (
  maxPlayers: TMaxPlayers,
  playerNumber: number
): IBlackjackPlayerPosition => {
  switch (maxPlayers) {
    case 2:
      switch (playerNumber) {
        case 1:
          return 'ML';
      }
      break;

    case 3:
      switch (playerNumber) {
        case 1:
          return 'ML';
        case 2:
          return 'MR';
      }
      break;

    case 4:
      switch (playerNumber) {
        case 1:
          return 'ML';
        case 2:
          return 'MR';
        case 3:
          return 'TL';
      }
      break;

    case 5:
      switch (playerNumber) {
        case 1:
          return 'ML';
        case 2:
          return 'MR';
        case 3:
          return 'TL';
        case 4:
          return 'BL';
      }
      break;

    case 6:
      switch (playerNumber) {
        case 1:
          return 'ML';
        case 2:
          return 'MR';
        case 3:
          return 'TL';
        case 4:
          return 'BL';
        case 5:
          return 'BR';
      }
      break;

    case 7:
      switch (playerNumber) {
        case 1:
          return 'ML';
        case 2:
          return 'MR';
        case 3:
          return 'TL';
        case 4:
          return 'BL';
        case 5:
          return 'BR';
        case 6:
          return 'TR';
      }

      break;
  }

  return 'BC';
};

export const getCardValue = (card: string): number => {
  const cardValue = card[0];

  if (!isNaN(parseInt(cardValue))) {
    const value = parseInt(cardValue);
    return value === 1 ? 10 : value;
  }

  switch (cardValue) {
    case 'J':
      return 10;
    case 'K':
      return 10;
    case 'Q':
      return 10;
    case 'A':
      return 11;
    default:
      return parseInt(cardValue);
  }
};

export const calculateBlackjackCardsPoints = (
  cards: IBlackjackPlayerCardsObject[]
): {
  points: number;
  nAces: number;
} => {
  const hand = cards.map((card) => card.type);
  let points = 0;
  let nAces = 0;

  hand.forEach((card) => {
    const value = getCardValue(card);
    if (value === 11) {
      if (nAces === 0) {
        points += value;
      } else {
        points++;
      }
      nAces++;
    } else {
      points += value;
    }
  });

  return {
    points: points > 21 && nAces > 0 ? points - 10 : points,
    nAces,
  };
};

export const getRoomGames = (
  room: IBlackjackRoom,
  currentGameUid?: string
): IBlackjackGame[] => {
  const allGames: IBlackjackGame[] = [
    { ...room.current_game },
    ...room.recent_games.filter(
      (game) => game.game_metadata.status === 'active'
    ),
  ];

  if (!currentGameUid) return allGames;

  const gamesWithoutCurrentGame: IBlackjackGame[] = allGames.filter(
    (game) => game.uid !== currentGameUid
  );

  return gamesWithoutCurrentGame;
};
